import { trustHTML } from "@ember/template";
import FormFieldCheckbox from "../checkbox";
import CustomFieldBase from "./base";

export default class CustomFieldConfirm extends CustomFieldBase {
  get description() {
    const description = super.description;
    if (!description) {
      return null;
    }

    return trustHTML(description);
  }

  <template>
    <FormFieldCheckbox
      ...attributes
      @name={{@field.name}}
      @title={{this.title}}
      @showTitle={{this.shouldDisplayTitle}}
      @description={{this.description}}
      @showDescription={{this.shouldDisplayDescription}}
      @placeholder={{this.placeholder}}
      @showPlaceholder={{this.shouldDisplayPlaceholder}}
      @required={{@field.required}}
      @autofocus={{@autofocus}}
      @value={{@value}}
      @onChange={{@onChange}}
      @validation={{@validation}}
    >
      {{yield}}
    </FormFieldCheckbox>
  </template>
}
